/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_CategoriesInputs */

const en_admin_sidebar_categories = /** @type {(inputs: Admin_Sidebar_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const de_admin_sidebar_categories = /** @type {(inputs: Admin_Sidebar_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungen`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Admin_Sidebar_CategoriesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_categories = /** @type {((inputs?: Admin_Sidebar_CategoriesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_CategoriesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_categories(inputs)
	return en_admin_sidebar_categories(inputs)
});